import { render, staticRenderFns } from "./TicketsPage.vue?vue&type=template&id=f5ea1c16&scoped=true&"
import script from "./TicketsPage.vue?vue&type=script&lang=js&"
export * from "./TicketsPage.vue?vue&type=script&lang=js&"
import style0 from "./TicketsPage.vue?vue&type=style&index=0&id=f5ea1c16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ea1c16",
  null
  
)

export default component.exports